"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLOBAL_NAV_FIXED_ITEMS = void 0;
var CDN_HOSTNAME = process.env.CDN_HOSTNAME || 'https://cdn.digital.greatminds.org';
var GLOBAL_NAV_ASSETS = 'global-nav/images';
var EurekaMathNavigatorItem = {
    id: 'em-nav',
    code: 'em-nav',
    title: 'Eureka Math Navigator',
    priority: 998,
    logo: "".concat(CDN_HOSTNAME, "/").concat(GLOBAL_NAV_ASSETS, "/product/EM-navigator.svg"),
    url: '/auth/launch/eureka-math-navigator',
    forStudents: false
};
var ManageItem = {
    id: 'Manage',
    code: 'manage',
    title: 'Manage',
    priority: 999, // It should always be the last item in the global nav options list
    logo: "".concat(CDN_HOSTNAME, "/").concat(GLOBAL_NAV_ASSETS, "/product/manage.svg"),
    url: '/manage',
    forStudents: false
};
/**
 * These options are used only by Teachers and Admins, not students
 */
exports.GLOBAL_NAV_FIXED_ITEMS = {
    all: [EurekaMathNavigatorItem, ManageItem],
    EurekaMathNavigatorItem: EurekaMathNavigatorItem,
    ManageItem: ManageItem
};
